export function getApiErrorMessage(error: unknown, fallback = "Xatolik yuz berdi."): string {
  const anyError = error as {
    response?: { status?: number; data?: { detail?: string } }
    config?: { url?: string; baseURL?: string }
    message?: string
    code?: string
  }
  const status = anyError?.response?.status
  const detail = anyError?.response?.data?.detail

  if (status === 401) {
    return "Sessiya muddati tugagan. Mini App'ni qayta oching."
  }
  if (status === 403) {
    return "Bu amalga ruxsat yo'q."
  }
  if (status === 404) {
    return "Ma'lumot topilmadi."
  }
  if (status === 422) {
    return detail || "Kiritilgan ma'lumotlarni tekshiring."
  }
  if (status === 429) {
    return "So'rovlar ko'p. Bir ozdan keyin qayta urinib ko'ring."
  }
  if (status && status >= 500) {
    return "Serverda xatolik. Birozdan keyin qayta urinib ko'ring."
  }

  if (!status && (anyError?.code === 'ERR_NETWORK' || anyError?.message === 'Network Error')) {
    return "Serverga ulanib bo'lmadi. Internet aloqangizni tekshiring yoki sahifani yangilang."
  }

  return detail || anyError?.message || fallback
}
